import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import api from '../services/api';
import jwtDecode from 'jwt-decode';
import { useNavigate, useLocation } from 'react-router-dom';

interface Monitor {
  id: string;
  estabId: string;
  storeId: string;
}

interface LoginParams {
  key: string;
  code_auth: string;
}

interface MonitorAuthContextType {
  monitor: Monitor | null;
  login: (params: LoginParams) => Promise<Monitor>;
  logout: () => void;
}

const MonitorAuthContext = createContext<MonitorAuthContextType | null>(null);

interface ProviderProps {
  children: ReactNode;
}

export const MonitorAuthProvider: React.FC<ProviderProps> = ({ children }) => {
  const [monitor, setMonitor] = useState<Monitor | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const login = async ({ key, code_auth }: LoginParams) => {
    const response = await api.post('/authMonitor', { key, code_auth });
    const token = response.data;
    localStorage.setItem('monitorToken', token);
    const decoded = jwtDecode<any>(token);
    const monitorData = {
      id: decoded.uid,
      estabId: decoded.claims.estabId,
      storeId: decoded.claims.storeId,
    };
    setMonitor(monitorData);
    return monitorData;
  };

  const logout = () => {
    setMonitor(null);
    localStorage.removeItem('monitorToken');
  };

  useEffect(() => {
    const token = localStorage.getItem('monitorToken');
    if (token) {
      const decoded = jwtDecode<any>(token);
      const monitorData = {
        id: decoded.uid,
        estabId: decoded.claims.estabId,
        storeId: decoded.claims.storeId,
      };
      setMonitor(monitorData);
      if (location.pathname === '/monitor_login') {
        navigate('/orderMonitor');
      }
    } else {
      if (location.pathname === '/orderMonitor') {
        navigate('/monitor_login');
      }
    }
  }, []);

  return (
    <MonitorAuthContext.Provider value={{ monitor, login, logout }}>
      {children}
    </MonitorAuthContext.Provider>
  );
};

export const useMonitorAuth = () => {
  const context = useContext(MonitorAuthContext);
  if (!context) {
    throw new Error('');
  }
  return context;
};
